import React from "react";
import { GeoJSON, Popup, Marker } from "react-leaflet";
import L from "leaflet";

const STYLE = { color: "#94A3B8", weight: 1.2, fillOpacity: 0.03, fillColor: "#94A3B8", dashArray: "5 3" };

export default function FireZonesLayer({ zones = [], alerts = [] }) {
  return zones.map((z) => {
    const zoneAlerts = alerts.filter((a) => (a.zones || []).includes(z.code));
    return (
    <React.Fragment key={`fz-${z.code}`}>
      <GeoJSON data={{ type: "Feature", geometry: z.geometry, properties: {} }} style={() => STYLE}>
        <Popup>
          <div className="min-w-[190px] max-w-[250px]" data-testid={`fire-zone-popup-${z.code}`}>
            <div className="text-[10px] font-bold uppercase tracking-wider text-tac-dim mb-1">
              NWS Fire Weather Zone
            </div>
            <div className="font-display font-bold text-sm text-tac-text">{z.code}</div>
            {z.name && <div className="text-[12px] text-tac-dim leading-snug">{z.name}</div>}
            <div className="mt-2 pt-1.5 border-t border-tac-border/60">
              <div className="text-[9px] font-bold uppercase tracking-wider text-tac-faint mb-1">
                Active alerts for this zone
              </div>
              {zoneAlerts.length === 0 ? (
                <div className="text-[11px] text-tac-safe" data-testid={`fire-zone-no-alerts-${z.code}`}>
                  ✓ None
                </div>
              ) : (
                <div className="space-y-1" data-testid={`fire-zone-alerts-${z.code}`}>
                  {zoneAlerts.map((a) => (
                    <div key={a.id} className="text-[11px] leading-snug">
                      <span className="font-bold" style={{ color: /red flag/i.test(a.event || "") ? "#E63946" : "#FFB703" }}>
                        {a.event}
                      </span>
                      {a.expires && (
                        <span className="text-tac-faint">
                          {" "}· until {new Date(a.expires).toLocaleString(undefined, { weekday: "short", hour: "numeric", minute: "2-digit" })}
                        </span>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Popup>
      </GeoJSON>
      {z.center && (
        <Marker
          position={[z.center.lat, z.center.lon]}
          interactive={false}
          icon={L.divIcon({
            className: "",
            html: `<div style="display:inline-block;transform:translate(-50%,-50%);padding:1px 5px;font:700 10px/1.4 'JetBrains Mono',monospace;letter-spacing:0.05em;color:#FFFFFF;background:rgba(10,13,12,0.72);border:1px solid #94A3B855;border-radius:2px;white-space:nowrap;pointer-events:none;">${z.code}</div>`,
            iconSize: null,
          })}
        />
      )}
    </React.Fragment>
    );
  });
}
